import { Text, VStack } from '@chakra-ui/react'
import { ProductPageContext } from '@contexts/product-page'
import isEmpty from 'lodash/isEmpty'
import { useContext } from 'react'

const ProductSpecifications = () => {
  const { product, selectedVariation } = useContext(ProductPageContext)

  const correspondingVariant = product?.variants?.find(
    (variant) => variant?._id === selectedVariation?._id,
  )

  const {
    weight: variantWeight,
    options: variantOptions,
    dimension: {
      height: variantHeight = undefined,
      length: variantLength = undefined,
      width: variantWidth = undefined,
      unit: variantDimensionUnit = undefined,
    } = {},
  } = correspondingVariant ?? {}

  const weight = variantWeight ?? product?.weight
  const height = variantHeight ?? product?.dimension?.height
  const width = variantWidth ?? product?.dimension?.width
  const length = variantLength ?? product?.dimension?.length
  const dimensionUnit = variantDimensionUnit ?? product?.dimension?.unit

  return (
    <VStack align="start">
      {!isEmpty(variantOptions) ? (
        <Text fontWeight="600">
          Variant -{' '}
          {variantOptions?.map((option, index, arr) => (
            <Text key={option?.id} as={'span'}>
              {option?.label}: {option?.name}
              {index !== arr.length - 1 ? ', ' : ''}
            </Text>
          ))}
        </Text>
      ) : null}

      {weight?.value ? (
        <Text>
          Weight: {weight?.value}
          {weight?.unit}
        </Text>
      ) : null}
      {length ? (
        <Text>
          Length: {length}
          {dimensionUnit}
        </Text>
      ) : null}
      {width ? (
        <Text>
          Width: {width}
          {dimensionUnit}
        </Text>
      ) : null}
      {height ? (
        <Text>
          Height: {height}
          {dimensionUnit}
        </Text>
      ) : null}
    </VStack>
  )
}

export default ProductSpecifications
